<template>
  <template v-if="isTelegramPage()">
    <span class="t1">{{ getTitle() }}</span> / <span class="t2" @click="onSite()">Сайте</span>
  </template>
  <template v-if="isSitePage()">
    <span class="t1">{{ getTitle() }}</span> / <span class="t2" @click="onTelegram()">Telegram</span>
  </template>
</template>

<script>
import {defineComponent, reactive} from "vue"
import {useRouter} from "vue-router"

export default defineComponent({
  name: "Title",
  components: {},
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const router = useRouter()

    let fields = reactive({
      title: "",
      page: "",
    })

    updateData(props.data)

    function updateData(data) {
      fields.title = data?.title
      fields.page = data?.page
    }

    function getTitle() {
      return fields.title
    }

    function getPage() {
      return fields.page
    }

    function isTelegramPage() {
      return getPage() === "telegram_comments"
    }

    function isSitePage() {
      return getPage() === "site_comments"
    }

    function onSite() {
      return router.push({name: "SiteComment"})
    }

    function onTelegram() {
      return router.push({name: "TelegramComment"})
    }

    return {
      getTitle,
      isTelegramPage,
      isSitePage,
      onSite,
      onTelegram,
    }
  }
})
</script>

<style src="./css/style.css" scoped></style>
